export class GetDefaultSettingDateViewModel {
  date: string
  defaultVacationDays: number
}
